var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-459 461 80 80"}},[_c('path',{attrs:{"d":"M-412.6 496.7c0 3.6-2.9 6.4-6.4 6.4-3.6 0-6.4-2.9-6.4-6.4 0-3.6 2.9-6.4 6.4-6.4 3.6 0 6.4 2.9 6.4 6.4m4.9-1.7c0-6.2-5-11.3-11.3-11.3-6.2 0-11.3 5-11.3 11.3 0 6.2 11.3 23.3 11.3 23.3s11.3-17.1 11.3-23.3"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4219b6e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/icons/Poi.vue
// module id = null
// module chunks = 